export default __webpack_public_path__ + "static/media/nasa-logo.b5bf6358.png";